<template>
  <div>
    <h1>Scale types</h1>
    <h2>Scale fee types</h2>
    <v-btn :to="{name:'scaleFeeTypeAdd'}">
      <v-icon>add</v-icon>Scale fee type
    </v-btn>
    <v-data-table
      :pagination.sync="pagination"
      :headers="headersFee"
      :items="scaleFeeTypes"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn :to="{name:'scaleFeeType', params:{id: props.item.id}}" small>{{ props.item.id }}</v-btn>
          </td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.description }}</td>
          <td>{{ props.item.exclude }}</td>
        </tr>
      </template>
    </v-data-table>
    <h2>Scale percentage types</h2>
    <v-btn :to="{name:'scalePercentageTypeAdd'}">
      <v-icon>add</v-icon>Scale percentage type
    </v-btn>
    <v-data-table
      :pagination.sync="pagination"
      :headers="headersPercentage"
      :items="scalePercentageTypes"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn
              :to="{name:'scalePercentageType', params:{id: props.item.id}}"
              small
            >{{ props.item.id }}</v-btn>
          </td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.description }}</td>
          <td>{{ props.item.exclude }}</td>
          <td>{{ props.item.band }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "ScaleTypes",
  metaInfo() {
    return {
      title: "Scale types",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      scaleFeeTypes: [],
      scalePercentageTypes: [],
      headersFee: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Name",
          value: "name"
        },
        {
          text: "Description",
          value: "description"
        },
        {
          text: "Exclude",
          value: "exclude"
        }
      ],
      headersPercentage: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Name",
          value: "name"
        },
        {
          text: "Description",
          value: "description"
        },
        {
          text: "Exclude",
          value: "exclude"
        },
        {
          text: "Band",
          value: "band"
        }
      ],
      pagination: {
        rowsPerPage: -1,
        sortBy: "name",
        descending: false
      }
    };
  },
  methods: {
    fetchScaleFeeTypes() {
      nbmlaw.get(`/cors/admin/sales/scaleFeeTypes`).then(response => {
        // console.log(response.data);
        this.scaleFeeTypes = response.data;
      });
    },
    fetchScalePercentageTypes() {
      nbmlaw.get(`/cors/admin/sales/scalePercentageTypes`).then(response => {
        // console.log(response.data);
        this.scalePercentageTypes = response.data;
      });
    }
  },
  created() {
    this.fetchScaleFeeTypes();
    this.fetchScalePercentageTypes();
  }
};
</script>